import type { FC } from 'react';

interface UkFlagProps {
    width?: string;
    height?: string;
}

const UkFlag: FC<UkFlagProps> = ({ width = '40', height = '30' }) => (
    <svg
        aria-hidden="true"
        focusable="false"
        width={width}
        height={height}
        viewBox="0 0 40 30"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="40" height="30" rx="4" fill="#012169" />
        <path d="M0 0H4L40 25.5V30H36L0 4.5V0ZM40 0H36L0 25.5V30H4L40 4.5V0Z" fill="#fff" />
        <path d="M0 0H2L40 28.5V30H38L0 1.5V0ZM40 0H38L0 28.5V30H2L40 1.5V0Z" fill="#C8102E" />
        <path d="M0 11H40V19H0V11ZM16 0H24V30H16V0Z" fill="#fff" />
        <path d="M0 12H40V18H0V12ZM17 0H23V30H17V0Z" fill="#C8102E" />
    </svg>
);

export default UkFlag;
